import { Typography } from "@mui/material";
import { Formik } from "formik";
import React, { useState, useEffect } from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { Button as MuiButton } from "@mui/material";
import Modal from "react-bootstrap/Modal";
import { TiDelete } from "react-icons/ti";
import { toast, ToastContainer } from "react-toastify";
import { object, string } from "yup";
import { API } from "../../../api/API";

const ModifiModule = ({
  show,
  handleClose,
  moduleId,
  initialData,
  onRefresh,
}) => {
  const [elements, setElements] = useState({});
  const [groups, setGroups] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (initialData && show) {
      // Séparer les éléments simples des groupes
      const initialElements = {};
      const initialGroups = {};

      Object.entries(initialData.content || {}).forEach(([key, value]) => {
        if (value.items) {
          // C'est un groupe
          initialGroups[key] = value;
        } else {
          // C'est un élément simple
          initialElements[key] = value;
        }
      });

      setElements(initialElements);
      setGroups(initialGroups);
      setIsLoading(false);
    }
  }, [initialData, show]);

  const handleAddElement = () => {
    const newKey = `element_${Object.keys(elements).length + 1}`;
    setElements({
      ...elements,
      [newKey]: { name: "", description: "", taux: "" },
    });
  };

  const handleAddGroup = () => {
    const newGroupKey = `group_${Object.keys(groups).length + 1}`;
    setGroups({
      ...groups,
      [newGroupKey]: {
        label: "",
        description: "",
        items: {},
      },
    });
  };

  const handleAddItemToGroup = (groupKey) => {
    const newItemKey = `item_${Object.keys(groups[groupKey].items).length + 1}`;
    setGroups({
      ...groups,
      [groupKey]: {
        ...groups[groupKey],
        items: {
          ...groups[groupKey].items,
          [newItemKey]: { name: "", description: "", taux: "" },
        },
      },
    });
  };

  const handleRemoveElement = (key) => {
    const updatedElements = { ...elements };
    delete updatedElements[key];
    setElements(updatedElements);
  };

  const handleRemoveGroup = (groupKey) => {
    const updatedGroups = { ...groups };
    delete updatedGroups[groupKey];
    setGroups(updatedGroups);
  };

  const handleRemoveItemFromGroup = (groupKey, itemKey) => {
    const updatedGroupItems = { ...groups[groupKey].items };
    delete updatedGroupItems[itemKey];
    setGroups({
      ...groups,
      [groupKey]: {
        ...groups[groupKey],
        items: updatedGroupItems,
      },
    });
  };

  const resetFormData = () => {
    if (initialData) {
      const initialElements = {};
      const initialGroups = {};

      Object.entries(initialData.content || {}).forEach(([key, value]) => {
        if (value.items) {
          initialGroups[key] = value;
        } else {
          initialElements[key] = value;
        }
      });

      setElements(initialElements);
      setGroups(initialGroups);
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={5000} />

      <Modal show={show} size="xl" centered onHide={handleClose}>
        <Modal.Header closeButton className="bg-success text-light">
          <Modal.Title>Modifier le module</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!isLoading && (
            <Formik
              initialValues={{
                label: initialData.label || "",
                description: initialData.description || "",
                content: {},
              }}
              onSubmit={async (values, { setSubmitting }) => {
                try {
                  values.content = {
                    ...elements,
                    ...groups,
                  };

                  const resp = await API.put(`/modules/${moduleId}`, {
                    ...values,
                  });
                  if (resp.status === 200) {
                    setSubmitting(false);
                    onRefresh();
                    toast.success("Module mis à jour avec succès");
                    handleClose();
                  }
                } catch (error) {
                  console.log("error", error);
                  toast.error("Erreur lors de la mise à jour du module");
                  setSubmitting(false);
                }
              }}
            >
              {({
                values,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                resetForm,
                ...rest
              }) => (
                <Form noValidate onSubmit={handleSubmit}>
                  <Row className="border-bottom border-2 pb-2 ">
                    <Form.Group as={Col}>
                      <Form.Label>Nom du module</Form.Label>
                      <InputGroup hasValidation>
                        <Form.Control
                          name="label"
                          required
                          type="text"
                          value={values.label}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Nom du module"
                        />
                      </InputGroup>
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Label>Description</Form.Label>
                      <InputGroup hasValidation>
                        <Form.Control
                          name="description"
                          type="text"
                          value={values.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Description"
                        />
                      </InputGroup>
                    </Form.Group>
                  </Row>

                  {Object.entries(elements).map(([key, element], index) => (
                    <Row key={key} className="align-items-center my-2">
                      <Form.Group as={Col}>
                        <Form.Label>Élément {index + 1}</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <span onClick={() => handleRemoveElement(key)}>
                              <TiDelete />
                            </span>
                          </InputGroup.Text>
                          <Form.Control
                            name={`content.${key}.name`}
                            type="text"
                            value={element.name}
                            onChange={(e) => {
                              const updatedElements = { ...elements };
                              updatedElements[key].name = e.target.value;
                              setElements(updatedElements);
                            }}
                            onBlur={handleBlur}
                            placeholder="Nom de l'élément"
                          />
                        </InputGroup>
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Form.Label></Form.Label>
                        <Form.Control
                          name={`content.${key}.description`}
                          type="text"
                          value={element.description}
                          onChange={(e) => {
                            const updatedElements = { ...elements };
                            updatedElements[key].description = e.target.value;
                            setElements(updatedElements);
                          }}
                          onBlur={handleBlur}
                          placeholder="Description de l'élément"
                        />
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Form.Label></Form.Label>
                        <Form.Control
                          name={`content.${key}.taux`}
                          type="numeric"
                          value={element.taux}
                          onChange={(e) => {
                            const updatedElements = { ...elements };
                            updatedElements[key].taux = e.target.value;
                            setElements(updatedElements);
                          }}
                          onBlur={handleBlur}
                          placeholder="Taux de l'élément"
                        />
                      </Form.Group>
                    </Row>
                  ))}

                  {Object.entries(groups).map(([groupKey, group], index) => (
                    <div key={groupKey} className="bg-light p-3 my-2">
                      <Row className="mb-2 ">
                        <Form.Group as={Col}>
                          <Form.Label>Groupe {index + 1}</Form.Label>
                          <InputGroup>
                            <InputGroup.Text>
                              <span onClick={() => handleRemoveGroup(groupKey)}>
                                <TiDelete />
                              </span>
                            </InputGroup.Text>
                            <Form.Control
                              name={`content.${groupKey}.label`}
                              type="text"
                              value={group.label}
                              onChange={(e) => {
                                const updatedGroups = { ...groups };
                                updatedGroups[groupKey].label = e.target.value;
                                setGroups(updatedGroups);
                              }}
                              onBlur={handleBlur}
                              placeholder="Nom du groupe"
                            />
                          </InputGroup>
                        </Form.Group>

                        <Form.Group as={Col}>
                          <Form.Label> {} </Form.Label>
                          <Form.Control
                            name={`content.${groupKey}.description`}
                            type="text"
                            value={group.description}
                            onChange={(e) => {
                              const updatedGroups = { ...groups };
                              updatedGroups[groupKey].description =
                                e.target.value;
                              setGroups(updatedGroups);
                            }}
                            onBlur={handleBlur}
                            placeholder="Description du groupe"
                          />
                        </Form.Group>
                      </Row>

                      {Object.entries(group.items).map(
                        ([itemKey, item], itemIndex) => (
                          <Row
                            key={itemKey}
                            className="align-items-center my-1 mx-2"
                          >
                            <Form.Group as={Col}>
                              <InputGroup>
                                <InputGroup.Text>
                                  <span
                                    onClick={() =>
                                      handleRemoveItemFromGroup(
                                        groupKey,
                                        itemKey
                                      )
                                    }
                                  >
                                    <TiDelete />
                                  </span>
                                </InputGroup.Text>

                                <Form.Control
                                  name={`content.${groupKey}.items.${itemKey}.name`}
                                  type="text"
                                  value={item.name}
                                  onChange={(e) => {
                                    const updatedGroups = { ...groups };
                                    updatedGroups[groupKey].items[
                                      itemKey
                                    ].name = e.target.value;
                                    setGroups(updatedGroups);
                                  }}
                                  onBlur={handleBlur}
                                  placeholder={`Nom de l'élément ${itemIndex + 1}`}
                                />
                              </InputGroup>
                            </Form.Group>
                            <Form.Group as={Col}>
                              <Form.Control
                                name={`content.${groupKey}.items.${itemKey}.description`}
                                type="text"
                                value={item.description}
                                onChange={(e) => {
                                  const updatedGroups = { ...groups };
                                  updatedGroups[groupKey].items[
                                    itemKey
                                  ].description = e.target.value;
                                  setGroups(updatedGroups);
                                }}
                                onBlur={handleBlur}
                                placeholder="Description de l'élément"
                              />
                            </Form.Group>
                            <Form.Group as={Col}>
                              <Form.Control
                                name={`content.${groupKey}.items.${itemKey}.taux`}
                                type="numeric"
                                value={item.taux}
                                onChange={(e) => {
                                  const updatedGroups = { ...groups };
                                  updatedGroups[groupKey].items[itemKey].taux =
                                    e.target.value;
                                  setGroups(updatedGroups);
                                }}
                                onBlur={handleBlur}
                                placeholder="Taux de l'élément"
                              />
                            </Form.Group>
                          </Row>
                        )
                      )}
                      <Button
                        variant="secondary"
                        type="button"
                        className="my-1 "
                        onClick={() => handleAddItemToGroup(groupKey)}
                      >
                        + Élément
                      </Button>
                    </div>
                  ))}

                  <Button
                    variant="secondary"
                    type="button"
                    onClick={handleAddElement}
                  >
                    + Élément
                  </Button>
                  <Button
                    variant="secondary"
                    type="button"
                    onClick={handleAddGroup}
                    className="mx-2"
                  >
                    + Groupe
                  </Button>
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    className="btn m-2 btn-success "
                  >
                    {isSubmitting ? "Enregistrement..." : "Mettre à jour"}
                  </Button>
                  <Button
                    onClick={resetFormData}
                    disabled={isSubmitting}
                    className="btn m-2 btn-warning "
                  >
                    Réinitialiser
                  </Button>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" type="button" onClick={handleClose}>
            Fermer
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModifiModule;
